import { render, staticRenderFns } from "./gwylChart.vue?vue&type=template&id=f65888b0&scoped=true"
import script from "./gwylChart.vue?vue&type=script&lang=js"
export * from "./gwylChart.vue?vue&type=script&lang=js"
import style0 from "./gwylChart.vue?vue&type=style&index=0&id=f65888b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65888b0",
  null
  
)

export default component.exports